import React from "react";
import "./ModalBox.css";
import CloseButton from "./CloseButton/CloseButton";

class ModalBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div
        className={
          this.props.modalClassName
            ? "modal-background " + this.props.modalClassName
            : "modal-background"
        }
      >
        <div className="modal-container">
          <CloseButton handleOnClick={this.props.handleModalOnClose} />
          <div className="modal-box">{this.props.children}</div>
        </div>
      </div>
    );
  }
}

export default ModalBox;
